import {
  CenterFocusStrongOutlined as FitViewIcon,
  CloseFullscreenOutlined as CloseFullscreenIcon,
  Fullscreen as FullscreenIcon,
  SvgIconComponent,
  ZoomInOutlined as ZoomInIcon,
  ZoomOutOutlined as ZoomOutIcon,
} from '@mui/icons-material';
import { Box, IconButton, Tooltip, SxProps, Theme } from '@mui/material';
import React from 'react';

interface ControlButtonProps {
  onClick: () => void;
  title: string;
  Icon: SvgIconComponent;
  active?: boolean;
}

const ControlButton: React.FC<ControlButtonProps> = ({ onClick, title, Icon, active }) => {
  return (
    <Tooltip title={title}>
      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          backgroundColor: active ? 'primary.light' : 'transparent',
          '&:hover': {
            backgroundColor: active ? 'primary.light' : 'action.hover',
          },
          color: active ? 'primary.main' : 'inherit',
          padding: { xs: '6px', sm: '8px' },
        }}
      >
        <Icon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

interface ZoomControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFitView: () => void;
  isFitViewToggled: boolean;
  onExpandToggle: () => void;
  isExpanded: boolean;
  sx?: SxProps<Theme>;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({
  onZoomIn,
  onZoomOut,
  onFitView,
  isFitViewToggled,
  onExpandToggle,
  isExpanded,
  sx,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: { xs: 0.25, sm: 0.5 },
        backgroundColor: 'background.paper',
        borderRadius: { xs: 1.5, sm: 2 },
        padding: { xs: '3px', sm: '4px' },
        boxShadow: { xs: 3, sm: 2 },
        zIndex: 1000,
        ...sx,
      }}
    >
      <ControlButton onClick={onZoomIn} title="Zoom In" Icon={ZoomInIcon} />
      <ControlButton onClick={onZoomOut} title="Zoom Out" Icon={ZoomOutIcon} />
      <ControlButton
        onClick={onFitView}
        title={isFitViewToggled ? 'Reset View' : 'Fit to View'}
        Icon={FitViewIcon}
        active={isFitViewToggled}
      />
      <ControlButton
        onClick={onExpandToggle}
        title={isExpanded ? 'Exit Fullscreen' : 'Enter Fullscreen'}
        Icon={isExpanded ? CloseFullscreenIcon : FullscreenIcon}
        active={isExpanded}
      />
    </Box>
  );
};
